import DecoratorConstants from './DecoratorConstants';


class Text {
  static title(id, name) {
    return `#${id} - ${name}`;
  }

  static platformName(platform) {
    if (!platform) {
      return '';
    }
    const osName = DecoratorConstants.displayNameByOS(platform.osName);
    const osVersion = DecoratorConstants.displayNameByOS(platform.osVersion);

    const extractOS = (str, fallbackEmpty = false) => {
      const lower = str.toLowerCase();
      if (lower.includes('macos') || lower.includes('mac')) return 'macos';
      if (lower.includes('ios')) return 'ios';
      if (lower.includes('android')) return 'android';
      if (lower.includes('windows')) return 'windows';
      if (lower.includes('linux')) return 'linux';
      return fallbackEmpty ? '' : str;
    };

    const osFromName = extractOS(osName);
    const osFromVersion = extractOS(osVersion, true);

    if (osVersion.indexOf(osName) < 0) {
      if (osFromVersion && osFromVersion !== osFromName) {
        return osName; // Different OS detected, return osName only
      }
      return `${osName} ${osVersion}`; // Same or no OS, concat as before
    }
    return osVersion;
  }

  static browserName(platform) {
    if (!platform) {
      return '';
    }
    const browserName = platform.browserName || '';
    const browserVersion = platform.browserVersion || '';
    let platformName;
    if (browserVersion.indexOf(browserName) < 0) {
      platformName = `${browserName} ${browserVersion}`;
    } else {
      platformName = browserVersion;
    }
    return platformName;
  }

  static copyToClipboard(content) {
    const el = document.createElement('textarea');
    el.value = content;
    el.setAttribute('readonly', '');
    el.style = { display: 'none' };
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
}

export default Text;
